import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'notificaciones',
  standalone: false,
  templateUrl: 'notificaciones.component.html',
  styleUrls: ['notificaciones.component.scss']

})

export class NotificacionesComponent implements OnInit {

  @Input()
  notifications;

  constructor() {
  }

  ngOnInit() {
  }
}
